<template>
  <footer class="p-5 has-background-light mt-6">
    <div class="container is-max-desktop is-size-7">
      <div class="links has-text-centered has-text-left-tablet">
        <a :href="`https://gimmemore.com/${locale}`" target="_blank">{{ $t('nav.home') }}</a>
        <a :href="`https://gimmemore.com/${locale}/imprint`" target="_blank">{{ $t('nav.imprint') }}</a>
        <a :href="`https://gimmemore.com/${locale}/terms`" target="_blank">{{ $t('nav.terms') }}</a>
        <a :href="`https://gimmemore.com/${locale}/data-protection`" target="_blank">{{ $t('nav.gdpr') }}</a>
        <a href="https://www.digitalstarters.com/careers" target="_blank">{{ $t('nav.jobs') }}</a>
        <a href="https://www.digitalstarters.com" target="_blank">{{ $t('nav.about_us') }}</a>
      </div>
      <hr class="has-background-grey-light">
      <p class="has-text-grey">{{ $t('nav.disclaimer') }}</p>
      <hr class="has-background-grey-light is-hidden-tablet">
      <p class="has-text-grey is-hidden-mobile">
        &copy; {{ new Date().getFullYear() }} GimmeMore
      </p>
      <p class="has-text-grey is-hidden-tablet">
        <a href="https://gimmemore.com">Gimmemore</a> &copy; {{ new Date().getFullYear() }} All Rights Reserved.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: {
    locale: { type: String, default: 'en' },
  },
}
</script>

<style lang="scss" scoped>
a + a {
  margin-left: 15px;
}

@media (max-width: 768px) {
  footer {
    margin-top: 0 !important;
  }
}

@media (max-width: 1023px) {
  .links a {
    word-break: break-word;
  }

  a + a {
    border-left: 1px solid #7a7a7a;
    padding-left: 15px;
  }
}

@media (min-width: 1024px) {
  .container {
    padding-left: 70px;
    padding-right: 70px;
  }

  .links {
    text-transform: uppercase;
  }

  a {
    color: #7a7a7a;
  }
}
</style>